import React from "react";

import { EmptySubtitle, EmptyTitle, Wrapper } from "./styled";

const EMPTY_STATE_IMG = require("../../../../../../../assets/img/empty-box.svg");

interface IEmptyState {
  title: string;
  description: string;
}

export const EmptyState = ({ title, description }: IEmptyState) => {
  return (
    <Wrapper>
      <img src={EMPTY_STATE_IMG} />
      <EmptyTitle>{title}</EmptyTitle>
      <EmptySubtitle>{description}</EmptySubtitle>
    </Wrapper>
  );
};
